import React, { useEffect } from "react";
import PermissionTable from "./PermissionTable/PermissionTable";
import "./PermissionComp.scss";
import PermissionOverviewTable from "./PermissionOverviewTable/PermissionOverviewTable";

const PermissionComp = ({
  data,
  loading,
  setPagination,
  pagination,
  handlePagination,
}) => {
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: data?.count || 0,
    }));
  }, [data]);
  return (
    <div className="permissionCompMain">
      <PermissionOverviewTable
        data={data?.map((item, index) => ({
          ...item,
          key: index + 1,
        }))}
        loading={loading}
        pagination={pagination}
        setPagination={setPagination}
        handlePagination={handlePagination}
      />
    </div>
  );
};

export default PermissionComp;
